module.exports = __webpack_public_path__ + "img/icon_sec4_03.e6b09c65.png";